import React, { useState } from "react";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/lib/Async";
import { useDebouncedAsyncSelect } from "../../../../../../../Utils/Hooks/useDebounce";
import { CargasTancadaApi } from "../api/CargasTancadaApi";
import { DatosBascula } from "./DatosBascula";
import { formatOpcionBultoLabel } from "../../../../../helpers/formatValues";
import { CargasTable } from "./CargasTable";
import { IsAlmacenBultosSkim } from "../helpers/almacenSkim";
import { IsAlmacenReproceso } from "../helpers/almacenReproceso";
import { ContenidoReproceso } from "./ContenidoReproceso";
import { DisponibleReproceso } from "./DisponibleReproceso";

export const ListadoCargas = (props) => {
    const { idTancada, cargasFormHook } = props;

    const {
        cargasTancada = [],
        numeroTancada,
        form,

        refreshBultosKey,
        reproceso,
        AgregarCargaTancada,
        EliminarCargaTancada,
        basculaConectada,
    } = cargasFormHook;

    const { getAlmacenes, getBultosSkim } = CargasTancadaApi();

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: watchForm,
        formState: { errors: formErrors },
    } = form;

    const loadAlmacenes = useDebouncedAsyncSelect(function (search) {
        if (!idTancada) {
            return Promise.resolve([]); // no consulta
        }

        return getAlmacenes(idTancada, { search: search });
    });

    const loadBultosSkim = useDebouncedAsyncSelect(function (search) {
        const almacenSeleccionado = formGetValues("almacen");
        const almacenId = almacenSeleccionado ? almacenSeleccionado.id : null;

        return getBultosSkim({ search: search, almacen_id: almacenId });
    }, 1000);

    const formValues = watchForm();
    const esAlmacenBultosSkim = IsAlmacenBultosSkim(formValues);
    const esAlmacenReproceso = IsAlmacenReproceso(formValues);

    const [modoResumen, setModoResumen] = useState(false);

    return (
        <React.Fragment>
            <h4 className="mb-0">
                Datos de tancada: {numeroTancada}
            </h4>
            <div className="d-flex justify-content-between flex-wrap align-items-end ">
                <div className="formulario-fields-row w-100 gap-2rem flex-wrap">
                    <div className="formulario-field">
                        <label className="text-nowrap">Almacén</label>
                        <Controller
                            name="almacen"
                            control={formControl}
                            rules={{
                                required: "Debe seleccionar un Almacén",
                            }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    key={idTancada || "empty"}
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    defaultOptions
                                    loadOptions={loadAlmacenes}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={(selected) => {
                                        field.onChange(selected);
                                    }}
                                />
                            )}
                        />
                        {formErrors.almacen && (
                            <small className="text-danger">
                                {formErrors.almacen.message}
                            </small>
                        )}
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">Materia prima</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                formValues.almacen &&
                                formValues.almacen.materia_prima
                                    ? formValues.almacen.materia_prima.nombre
                                    : ""
                            }
                        />
                    </div>

                    {esAlmacenReproceso && (
                        <DisponibleReproceso reprocesoHook={reproceso} />
                    )}

                    {esAlmacenBultosSkim && (
                        <div className="formulario-field">
                            <label className="text-nowrap">ID Bulto</label>
                            <Controller
                                name="bulto_skim"
                                control={formControl}
                                rules={{
                                    required: "Debe seleccionar un Bulto",
                                }}
                                render={({ field }) => (
                                    <AsyncSelect
                                        key={refreshBultosKey}
                                        {...field}
                                        className="react-select-container"
                                        isSearchable
                                        isClearable
                                        defaultOptions
                                        loadOptions={loadBultosSkim}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) =>
                                            formatOpcionBultoLabel(option)
                                        }
                                        onChange={(selected) => {
                                            field.onChange(selected);
                                        }}
                                    />
                                )}
                            />
                            {formErrors.bulto_skim && (
                                <small className="text-danger">
                                    {formErrors.bulto_skim.message}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {esAlmacenReproceso ? (
                <ContenidoReproceso cargasFormHook={cargasFormHook} />
            ) : (
                <DatosBascula
                    formControl={formControl}
                    formValues={formValues}
                    formErrors={formErrors}
                    basculaConectada={basculaConectada}
                />
            )}

            <div className="d-flex justify-content-between my-3 align-items-center">
                <span
                    className="btn-link-pointer"
                    onClick={() => setModoResumen(!modoResumen)}
                >
                    {modoResumen ? "Mostrar detalle" : "Mostrar resumen"}
                </span>

                {/* en reproceso la carga se agrega desde el modal */}
                {!esAlmacenReproceso && (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={AgregarCargaTancada}
                    >
                        Agregar
                    </button>
                )}
            </div>

            {/* TABLA DE ORDENES DE PRODUCCION */}
            <CargasTable
                cargasTancada={cargasTancada}
                modoResumen={modoResumen}
                EliminarCargaTancada={EliminarCargaTancada}
            />
        </React.Fragment>
    );
};
